import SEO from "@/components/SEO";
import Overline from "@/components/Overline";
import { company, seo } from "@/config/site";

export default function PrivacyPolicy() {
  return (
    <>
      <SEO
        title="Privacy Policy"
        description={`Privacy policy for the ${company.fullCompanyName} website.`}
        canonical={`${seo.siteUrl}/privacy-policy`}
      />
      <section className="border-b border-neutral-200 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-14 md:py-20">
          <Overline>Legal</Overline>
          <h1 className="font-heading mt-4 text-4xl sm:text-5xl font-bold tracking-tight text-neutral-900">Privacy Policy</h1>
        </div>
      </section>

      <section className="py-12">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <p className="text-neutral-600 leading-relaxed">
            This website is operated by {company.fullCompanyName} ("we", "us", "our"). This policy explains in general terms how information provided to us through the website is handled.
          </p>

          <h2 className="font-heading mt-8 text-xl font-semibold text-neutral-900">Enquiry information</h2>
          <p className="mt-2 text-neutral-600 leading-relaxed">
            The enquiry form on this website is powered by Google Forms. When you submit an enquiry, the information you provide — including your name, company name, business email, phone number, product interest and requirement details — is collected via Google Forms and used only to respond to your enquiry.
          </p>

          <h2 className="font-heading mt-8 text-xl font-semibold text-neutral-900">How we contact you</h2>
          <p className="mt-2 text-neutral-600 leading-relaxed">
            We use the contact details you provide to discuss your requirement. We do not sell or share your personal information with third parties unrelated to your enquiry.
          </p>

          <h2 className="font-heading mt-8 text-xl font-semibold text-neutral-900">Cookies & analytics</h2>
          <p className="mt-2 text-neutral-600 leading-relaxed">
            The website may use standard tools to understand how visitors use the site. These tools do not collect information that identifies you personally on this website.
          </p>

          <h2 className="font-heading mt-8 text-xl font-semibold text-neutral-900">Retention</h2>
          <p className="mt-2 text-neutral-600 leading-relaxed">
            Enquiries and related correspondence are retained for a period reasonable to the nature of the business relationship. You may contact us to request removal of your data.
          </p>

          <h2 className="font-heading mt-8 text-xl font-semibold text-neutral-900">Contact</h2>
          <p className="mt-2 text-neutral-600 leading-relaxed">
            For any questions related to this policy, please contact us at {company.phone}
            {company.email ? ` or ${company.email}` : ""}.
          </p>
        </div>
      </section>
    </>
  );
}
